import CardStateHelper from '../CardStateHelper';
import BaseCardBehavior from './BaseCardBehavior';
import { CardTask } from '../CardTasks';
import {
    SCORE_TORNADO_CARD,
    SCORE_TORNADO_TARGET_CARD,
} from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { ICardsState, ValueCardData } from '../ICardState';

export default class TornadoCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = state.levelState.cardsState;
        const targets = CardStateHelper.getValueCards(cardsState)
            .filter(cardID => {
                const behavior = CardStateHelper.getCardBehavior(
                    cardsState,
                    cardID
                );
                return (
                    behavior.isFaceUp(cardsState) &&
                    !behavior.isBlocked(cardsState)
                );
            })
            .map(cardID => ({
                cardID: cardID,
                oldValue: (cardsState.cards[cardID] as ValueCardData).value,
                newValue: null,
            }));

        // Shuffle all in-play value cards.
        cardsState = CardStateHelper.shuffleValueCards(cardsState);

        const scores: number[] = [SCORE_TORNADO_CARD];

        // Set "newValue" after shuffling.
        targets.forEach(target => {
            target.newValue = (cardsState.cards[target.cardID] as ValueCardData).value;
            scores.push(SCORE_TORNADO_TARGET_CARD);
        });

        // Discard this card.
        cardsState = CardStateHelper.setCardDiscarded(cardsState, this.cardID);

        // Add score.
        cardsState = CardStateHelper.addTurnScore(
            cardsState,
            scores.reduce((a, c) => a + c, 0)
        );

        // Trigger tornado animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.TORNADO,
            cards: [this.cardID, ...targets.map(t => t.cardID)],
            cardsScore: [...scores],
            targets: targets,
        });

        // Clear undo history when a tornado card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState,
            },
        };
    }
}
